<template>
  <div class="arztsuche" :class="{ loading: contentLoading }">
    <div class="col_left">
      <SearchForm @update-locs="updateLocs" @load-change="loadChange" @pdfcall="pdfCall" :callPdfSearch="callPdfSearch"/>
    </div>
    <div class="col_right" ref="downloadPDFContent">
      <Map
        :pagedLocs="pagedLocs"
        :selectedLoc="selectedLoc"
        @select-loc="selectLoc"
        :printing="printing"
        :jj="callPdfSearch"
      />
      <div>
        <Results
          :locsIn="locs"
          :pagedLocs="pagedLocs"
          :selectedLoc="selectedLoc"
          @select-loc="selectLoc"
          @page-locs="pageLocs"
          @update-contentloading="updateContentloading"
          @download-pdf="downloadPDF"
          :formSubmitted="formSubmitted"
          :paginationRows="paginationRows"
          :downloadUrl="downloadUrl"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watchEffect } from "vue";
import html2pdf from "html2pdf.js";
import SearchForm from "@/components/SearchForm";
import Map from "@/components/Map";
import Results from "@/components/Results";
import appConf from "@/config/config.js";

export default {
  name: "App",
  components: { SearchForm, Map, Results },
  setup() {
    const locs = ref(false);
    const pagedLocs = ref([]);
    const selectedLoc = ref(null);
    const loading = ref(true);
    const formSubmitted = ref(0);
    const paginationRows = ref(10);
    const contentLoading = ref(false);
    const printing = ref(false);
    const downloadPDFContent = ref(null);
    const downloadUrl = ref(null);
    const callPdfSearch = ref(false);
    const searchForm = ref();

    const updateLocs = (locsIn) => {
      locs.value = locsIn;
      formSubmitted.value = 1;
    };

    const pageLocs = (pageInfo) => {
      if (locs.value) {
        pagedLocs.value = locs.value.slice(pageInfo.start, pageInfo.end);
      }
    };

    const selectLoc = (locId) => {
      selectedLoc.value = locId;
    };

    const loadChange = (loadingIn) => {
      let isLoading = false;
      for (const [key, value] of Object.entries(loadingIn.value)) {
        if (value) {
          isLoading = true;
        }
      }
      loading.value = isLoading;
    };

    const updateContentloading = (isLoading) => {
      contentLoading.value = isLoading;
    };

    const downloadPDF = () => {
      callPdfSearch.value = !callPdfSearch.value;
    };

    const pdfCall = (url) => {
      downloadUrl.value = url;
    }

    return {
      updateLocs,
      locs,
      pageLocs,
      pagedLocs,
      selectedLoc,
      selectLoc,
      loadChange,
      formSubmitted,
      downloadPDF,
      paginationRows,
      contentLoading,
      updateContentloading,
      downloadPDFContent,
      printing,
      pdfCall,
      downloadUrl,
      callPdfSearch 
    };
  },
};
</script>

